import { useNavigate } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import ArgonBox from 'component/Argon/ArgonBox';
import Stack from '@mui/material/Stack';

import DashboardLayout from 'layout/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'component/Navbars/DashboardNavbar';

import ArgonButton from 'component/Argon/ArgonButton';
import ArgonTypography from 'component/Argon/ArgonTypography';
import { Link } from '@mui/material';

function Mou() {
  const navigate = useNavigate();

  return (
    <DashboardLayout bgColor="transparent">
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <ArgonBox my={3} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Stack spacing={1} direction="row" mb={3}>
              <ArgonButton
                variant="gradient"
                color="info"
                size="large"
                fullWidth
                onClick={() => {
                  navigate('/policy-mou/form');
                }}
              >
                <ArgonTypography variant="h3" color="white">
                  ซื้อด้วยแบบฟอร์ม
                </ArgonTypography>
              </ArgonButton>
              <ArgonButton
                variant="gradient"
                color="info"
                fullWidth
                size="large"
                onClick={() => {
                  navigate('/policy-mou/excel');
                }}
              >
                <ArgonTypography variant="h2" color="white">
                  ซื้อด้วย Excel
                </ArgonTypography>
              </ArgonButton>
            </Stack>
            <ArgonBox>
              <Link
                component="button"
                onClick={() => {
                  let link = document.createElement('a');
                  link.rel = 'noopener noreferrer';
                  link.target = '_blank';
                  link.href = 'https://tkr.sgp1.cdn.digitaloceanspaces.com/sample/form.xlsx';

                  document.body.appendChild(link);
                  link.click();
                  link.parentNode.removeChild(link);
                }}
              >
                <ArgonTypography color="info" textGradient>
                  - ดาวน์โหลดไฟล์ Excel ต้นฉบับ
                </ArgonTypography>
              </Link>
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
    </DashboardLayout>
  );
}

export default Mou;
